import { countries } from 'i18n-iso-countries/langs/en.json'

type CountryCode = string

// redefine countryCodeToNameMap with enhanced typings and custom overrides
const countryCodeToNameMap: { [c in CountryCode]: string } = {
  ...countries,
  US: 'United States',
  RU: 'Russia',
}

interface Country {
  code: CountryCode
  name: string
}

export function sortCountriesAlphabetically(countryA: Country, countryB: Country) {
  const countryAName = countryA.name.toUpperCase()
  const countryBName = countryB.name.toUpperCase()
  return countryAName < countryBName ? -1 : countryAName > countryBName ? 1 : 0
}

function isValidCountryCode(countryCode = ''): countryCode is CountryCode {
  return !!countryCodeToNameMap[countryCode]
}

function getCountryName(countryCode: CountryCode): string {
  return countryCodeToNameMap[countryCode] || countryCode
}

export type { Country, CountryCode }
export { isValidCountryCode, getCountryName }
